import React, { useRef, useState } from 'react';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import DateCell from '../../../documents/components/cells/dateCell/dateCell';
import ActivityCell from './cells/activityCell/activityCell';
import HeaderCell from '../../../documents/components/cells/headerCell/headerCell';
import useTranslate from '../../../../common/hooks/useTranslate';
import TableLoading from '../../../ui/loaders/tableLoader/tableLoading';

import '@progress/kendo-theme-default/dist/all.css';
import '../../../ui/table/table.scss';
import './activityLog.scss';

const ActivityLog = (props) => {
  const [sort, setSort] = useState([{ field: 'date', dir: 'desc' }]);
  const { t } = useTranslate();
  const tableRef = useRef(null);
  return (
    <div className="table user-activity-wrapper">
      <div className="title-activity-wrapper">
        <span className="card-title">{t('ACTIVITY.LOG_CARD_TITLE')}</span>
      </div>
      <Grid
        data={props.activity}
        sortable={true}
        //@ts-ignore
        sort={sort}
        total={800}
        pageSize={40}
        filterable={true}
        scrollable="scrollable"
        onSortChange={(e) => {
          //@ts-ignore
          setSort(e.sort);
        }}
        ref={tableRef}
        selectedField="selected">
        <GridColumn field="name" title={t('ACTIVITY.LOG_COLUMN_NAME')} className="tableCell" headerCell={HeaderCell} />
        <GridColumn
          field="date"
          title={t('ACTIVITY.LOG_COLUMN_WHEN')}
          className="tableCell"
          //@ts-ignore
          cell={ActivityCell}
          headerCell={HeaderCell}
          width={200}
        />
        <GridColumn field="date" title={t('ACTIVITY.LOG_COLUMN_DATE')} className="tableCell" cell={DateCell} width={205} headerCell={HeaderCell} />
      </Grid>
      {props.loadingActivity && <TableLoading tableElement={tableRef} />}
    </div>
  );
};

export default ActivityLog;
